import React from 'react'

export const CheckInMonthSkeleton: React.FC = () => {
  return (
    <div className="pt-2 animate-pulse-card">
      <div className="flex overflow-auto justify-start gap-1 mb-2">
        {[...Array(6)].map((_, index) => (
          <div
            key={index}
            className="rounded-sm border py-4 px-1 flex-1 text-center border-gray-200 bg-gray-50"
            style={{ minWidth: '95px', maxWidth: '95px' }}
          >
            {/* Month name placeholder */}
            <div className="h-4 w-10 bg-gray-200 rounded-sm mx-auto mb-2"></div>
            {/* Icon and price placeholder */}
            <div className="flex flex-col items-center justify-center" style={{ minHeight: '40px' }}>
              <div className="w-5 h-5 bg-gray-200 rounded-full mb-2"></div>
              <div className="h-3 w-14 bg-gray-200 rounded-sm"></div>
            </div>
          </div>
        ))}
      </div>
      {/* Estimate text placeholder */}
      <div className="flex justify-end">
        <div className="h-3 w-40 bg-gray-200 rounded-sm"></div>
      </div>
    </div>
  )
}
